var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"building-game"},[_c('p5-vue-mirror',{attrs:{"scriptFiles":_vm.scriptFiles,"hidecode":true,"headerContent":_vm.headerContent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }